import { ReactNode } from "react";
import { Card, CardContent } from "@capacit-com/lara-law-shared-ui";
import { cn } from "@/lib/utils";

type Props = {
  icon: ReactNode;
  title: string;
  description: string;
  onClick?: () => void;
  className?: string;
};

const EmptyStateCard = ({
  icon,
  title,
  description,
  onClick,
  className,
}: Props) => {
  return (
    <Card
      className={cn(
        "cursor-pointer transition-all hover:shadow-md border-border dark:border-border border h-full flex flex-col",
        onClick && "hover:border-primary",
        className
      )}
      onClick={onClick}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={(e) => {
        if (onClick && (e.key === "Enter" || e.key === " ")) {
          e.preventDefault();
          onClick();
        }
      }}
      aria-label={onClick ? `${title}: ${description}` : undefined}
    >
      <CardContent className="flex flex-col p-4 gap-1 flex-1">
        <div className="flex items-center text-foreground dark:text-foreground justify-left mb-2 border-[0.5px] w-min p-2 rounded-md border-border dark:border-white">
          {icon}
        </div>
        <h3 className="font-semibold text-base text-foreground">{title}</h3>
        <p className="text-sm text-muted-foreground flex-1">{description}</p>
      </CardContent>
    </Card>
  );
};

export default EmptyStateCard;
